import React from 'react';
import { HeaderWithBalance } from '../styles';

export const RebuttalHeader = ({ description, balance }) => (
    <HeaderWithBalance>
        <h3>{description}</h3>
        <span><h2>$</h2><h2>{balance.slice(1)}</h2></span>
    </HeaderWithBalance>
);

export default RebuttalHeader;